import { Action } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { CAMPAIGN_ACTION_TYPE } from "./campaign.action";
import { CampaignState } from "./campaign.model";

const INITIAL_STATE: CampaignState = {
	isBusy: false,
};

export function campaignReducer(state = INITIAL_STATE, action: Action): CampaignState {
	switch (action.type) {
		case CAMPAIGN_ACTION_TYPE.joinByCode: {
			return updateState(state, {
				isBusy: true,
			});
		}
		case CAMPAIGN_ACTION_TYPE.joinByCodeSuccess:
		case CAMPAIGN_ACTION_TYPE.joinByCodeFail: {
			return updateState(state, {
				isBusy: false,
			});
		}
		case CAMPAIGN_ACTION_TYPE.optIn: {
			return updateState(state, {
				isBusy: true,
			});
		}
		case CAMPAIGN_ACTION_TYPE.optInSuccess:
		case CAMPAIGN_ACTION_TYPE.optInFail: {
			return updateState(state, {
				isBusy: false,
			});
		}
		default:
			return state;
	}
}
